import React from 'react';
import { BodyText } from "@hm-group/fabric-components/components/Typography";
import { MetaText } from "@hm-group/fabric-components/components/Typography";
import cn from 'classnames';
import "./ComparativePrice.css";
var styles = { "comparativePrice": "a32d3d", "hm": "bd1a4d", "northstar-small": "ba535d", "northstar-large": "a2eab5" };
const ComparativePrice = ({ quantity, formattedPrice, comparativeQuantity, variant = 'hm', }) => {
    let outputQuantity = '';
    let formattedPriceAndQuantity = '';
    let output = '';
    // We shouldn't render anything if we don't have all the data we need
    if (!quantity || !formattedPrice || !comparativeQuantity)
        return null;
    if (quantity || formattedPrice || comparativeQuantity) {
        if (quantity)
            outputQuantity = quantity;
        if (formattedPrice && comparativeQuantity)
            formattedPriceAndQuantity = `${formattedPrice} / ${comparativeQuantity}`;
    }
    if (outputQuantity || formattedPriceAndQuantity) {
        const separator = outputQuantity && formattedPriceAndQuantity && ` | `;
        output = `${outputQuantity}${separator}${formattedPriceAndQuantity}`;
    }
    else {
        return null;
    }
    const Tag = variant === 'hm' ? BodyText : MetaText;
    return React.createElement(Tag, { className: cn(styles.comparativePrice, styles[variant]) }, output);
};
export default ComparativePrice;
//# sourceMappingURL=ComparativePrice.js.map